export enum GENDER {
  MAN = "man",
  WOMAN = "woman",
}
